import { createTheme } from '@mui/material/styles';
import "@fontsource/roboto-slab"; 

export const theme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#212323',
      },
      secondary: {
        main: '#00d9f5',
      },
      background: {
        default: '#1f1f1f',
      },
    },
    typography: {
      fontFamily: 'Roboto Slab',
    },
  });